<template>
    <div v-if="hasResults">
        <div class="subcaption text-grey-600 px-3 mb-1">{{ props.contents.placeHolders.domains }}</div>

        <div
            class="subcaption text-grey-900 cursor-pointer py-1 item px-3 d-flex justify-content-between align-items-center"
            v-for="domain in domains"
            @click="handleSelect(domain)"
            :class="{
                'bg-primary-blue selected-item': isSelected(SeFields.DOMAINS, domain.id, props.store)
            }"
        >
            <span>{{ domain.label }}</span>
            <template v-if="isSelected(SeFields.DOMAINS, domain.id, props.store)">
                <CloseButton />
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {computed, ComputedRef} from "vue"

// state
import {AutocompleteState} from '../../../state/autocompleteState'

// logic
import setSelected from '../../../logic/setSelected'
import isSelected from '../../../logic/isSelected'
import unselect from '../../../logic/unselect'

// enums
import { SeFields } from '../../../enums/seFields'

// components
import CloseButton from '../../../components/close-button.vue'

const props = defineProps<{
    se: any
    store: any
    contents: any
    state: AutocompleteState
}>()

// Methods
const handleSelect = (domain: any) => {
    if (isSelected(SeFields.DOMAINS, domain.id, props.store)) {
        handleUnselect()
    } else {
        select(domain)
    }
}

const domains = computed(() => {
    return props.state.domains
})

const hasResults: ComputedRef<number> = computed(() => {
    return props.state.domains.length
})

const select = (domain: any) => {
    const { id, label } = domain
    setSelected(SeFields.DOMAINS, id, domain.label, props.store)
    props.store.libs.se.batch(() => {
        props.store.libs.se.setFieldValue(SeFields.DOMAINS, id)

        props.store.libs.se.setFieldValue(SeFields.STATION, undefined)
        props.store.libs.se.setFieldValue(SeFields.REGION, undefined)
        props.store.libs.se.setFieldValue(SeFields.PARENT_STATION, undefined)
    })
}

const handleUnselect = () => {
    unselect(props.store)
    props.store.libs.se.setFieldValue(SeFields.DOMAINS, undefined)
}
</script>
